import React from 'react';
import { Link } from 'react-router-dom';

interface NavbarPCLinkProps extends React.HTMLAttributes<HTMLElement> {
  link: string;
  children: React.ReactNode;
  className?: string;
}

const NavbarPCLink: React.FC<NavbarPCLinkProps> = ({ link, children, className, ...rest  }) => {
  return (
    <li {...rest} className={`nav-item nav-link-pc ${className ?? ''}`}>
      <Link to={link} className="nav-link icon-menu-dark">
        {children}
      </Link>
    </li>
  );
};

export default NavbarPCLink;
